var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 8.91692C18.0013 8.72474 17.9625 8.53439 17.8863 8.35798C17.81 8.18158 17.6978 8.02299 17.5569 7.89231L9 0L0.443107 7.89231C0.302188 8.02299 0.190018 8.18158 0.113736 8.35798C0.0374542 8.53439 -0.00126877 8.72474 3.17027e-05 8.91692V16.6154C3.17027e-05 16.9826 0.14591 17.3348 0.405575 17.5945C0.66524 17.8541 1.01742 18 1.38464 18H16.6154C16.9826 18 17.3348 17.8541 17.5944 17.5945C17.8541 17.3348 18 16.9826 18 16.6154V8.91692Z",
    fill: "#303336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkHomeIcon);
export default __webpack_public_path__ + "static/media/darkHomeIcon.badbb1181be0a733e4d3c6c3f979ebd2.svg";
export { ForwardRef as ReactComponent };